import { navbar, about, storeForU, teams, video, haveITaskCards, gallery, submission, offices, faq, footer } from '@apgm/constants';

// console.log('haveCardList', haveCardList);
function message () {
  return {
    application: {
      title: 'Shopee Apprentice Program',
      desc: 'Shopee Apprentice Program',
      startDate: '',
      endDate: ''
    },
    navbar,
    about,
    storeForU,
    teams,
    gallery,
    haveITaskCards,
    submission,
    video,
    offices,
    faq,
    footer,
  }
}

export default message;